import { ValidatorRule } from 'rc-field-form/lib/interface';

export const stringValidator: ValidatorRule['validator'] = (rule, value) => {
  if (!value) return Promise.reject('Should be not empty string!');
  if (typeof value !== 'string') return Promise.reject('Should be a string!');
  if (!value.trim()) return Promise.reject('Should be not empty string!');
  return Promise.resolve();
};
